export const FAQS = [
  {
    question: "What is My Private Shopper?",
    answer:
      "My Private Shopper (MPS) is a premium UK-to-Nigeria personal shopping concierge. We source, purchase, and ship UK products directly to clients in any of Nigeria's 36 states. MPS has been operating privately since 2011 and was formally UK-registered in 2023.",
  },
  {
    question: "How does the MPS personal shopping service work?",
    answer:
      "You tell us what you want — by product link, screenshot, or description. We send you a quote covering service fee + freight. On approval and payment, we purchase the item from the UK retailer, quality-check it at our consolidation point, and ship it to your address in Nigeria within 7 to 10 working days.",
  },
  {
    question: "What can I buy through My Private Shopper?",
    answer:
      "Almost anything legal to import. The most popular categories are designer fashion, luxury handbags and watches, electronics (laptops, TVs, phones, gaming), skincare and beauty, sportswear, home appliances, and gifts.",
  },
  {
    question: "Which countries does My Private Shopper ship to?",
    answer:
      "We currently ship from the United Kingdom to Nigeria. We deliver to all 36 Nigerian states plus the FCT (Abuja).",
  },
  {
    question: "Which Nigerian states does MPS deliver to?",
    answer:
      "All 36 states and the Federal Capital Territory (Abuja). Delivery times and freight rates vary by state — see our pricing page for the full breakdown.",
  },
  {
    question: "How long does delivery from the UK to Nigeria take?",
    answer:
      "End-to-end, expect 7 to 10 working days from dispatch out of the UK. Lagos arrivals are typically the fastest. Northern states may add 1 to 2 days for the onward leg.",
  },
  {
    question: "How much does My Private Shopper charge?",
    answer:
      "MPS charges a service fee (based on product value) plus freight to your Nigerian state. Service fees start at £20 flat for items up to £100. Freight starts at £35 for items under 2kg. Full rate card on the pricing page.",
  },
  {
    question: "How is the MPS service fee calculated?",
    answer:
      "Items under £100 are £20 flat. Items £101–£300 are 15% of product value. Items £301–£600 are 12%. Items above £600 are negotiated with a £75 minimum. Add £30 if you need MPS to source the item for you (no link provided).",
  },
  {
    question: "What is the freight/shipping cost to Nigeria?",
    answer:
      "Under 2kg: £35 flat. 2kg to 5kg: £50 flat. Above 5kg: per-kg rate to your destination state (Lagos from £6.50/kg). Fixed-price items like TVs and appliances ship at flat rates regardless of weight.",
  },
  {
    question: "Are there fixed shipping rates for electronics like laptops and TVs?",
    answer:
      "Yes. Laptops, tablets and iPads ship at £50 flat. TVs range from £120 (19\") to £850 (90\"). American fridges are £800. Washing machines are £550. Cookers are £250. All flat rates to Lagos.",
  },
  {
    question: "What if I don't have a product link?",
    answer:
      "No problem. Send us a screenshot, brand name, or description and our sourcing team will find it for you. A £30 sourcing fee is added for items without a direct product link.",
  },
  {
    question: "Can businesses use My Private Shopper?",
    answer:
      "Yes. We have a dedicated B2B procurement service for Nigerian businesses sourcing office equipment, electronics, branded merchandise, and consumables from UK suppliers. Volume rates available — contact us via WhatsApp.",
  },
  {
    question: "Can I order luxury or designer items through MPS?",
    answer:
      "Yes — luxury and designer items are one of our most active service tiers. We source only from authorised UK retailers (brand boutiques, Selfridges, Harrods, Liberty, Browns, Matches) and provide photographs at every stage. Luxury orders ship with full insurance.",
  },
  {
    question: "How do I place an order with My Private Shopper?",
    answer:
      "The fastest route is WhatsApp — tap the green button on any page. The structured route is our online order form which captures all your details and emails them directly to our ops team.",
  },
  {
    question: "How do I pay for my order?",
    answer:
      "Payment is by bank transfer once we have confirmed your quote. We do not take payment through the website — every order is reviewed and confirmed by a real person first.",
  },
  {
    question: "Is My Private Shopper legitimate and trustworthy?",
    answer:
      "Yes. MPS has been operating privately since 2011 and was formally UK-registered in 2023. We have shipped 500+ orders to Nigerian clients, and provide photo documentation at every stage. We source only from authorised UK retailers.",
  },
  {
    question: "What items cannot be shipped from the UK to Nigeria?",
    answer:
      "We cannot ship firearms, ammunition, hazardous materials, fresh produce, live animals, prescription medications without paperwork, or anything restricted under Nigerian Customs regulations. If you are unsure, ask us before ordering.",
  },
  {
    question: "Can I track my shipment?",
    answer:
      "Yes. We provide tracking updates at each leg — UK dispatch, international transit, Nigerian arrival, and last-mile delivery to your state.",
  },
  {
    question: "What happens if my item is damaged or lost?",
    answer:
      "All parcels are photographed before international shipment. Luxury orders ship with full insurance covering the declared value. For non-luxury items, we work directly with the freight provider to resolve any claim on your behalf.",
  },
  {
    question: "How is MPS different from buying directly from UK websites?",
    answer:
      "Most UK retailers reject Nigerian payment cards and do not ship to Nigerian addresses. MPS pays in GBP from verified UK accounts, consolidates multiple orders into one shipment, and provides a single accountable contact for the entire journey.",
  },
  {
    question: "Does MPS offer gift sourcing and delivery?",
    answer:
      "Yes. We offer a dedicated gift sourcing service including discreet packaging, gift cards, and direct delivery to a recipient in Nigeria without revealing the price.",
  },
  {
    question: "Can I send a gift directly to a recipient in Nigeria?",
    answer:
      "Yes. Provide the recipient's address and any gift message. We can ship in plain outer packaging and omit any pricing or invoice information.",
  },
];
